module.exports = "/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved\n *\n * Licensed under CLOUD LINUX LICENSE AGREEMENT\n * http://cloudlinux.com/docs/LICENSE.TXT\n */\ntd {\n  position: absolute;\n  border: none !important;\n}\n.spinner-block {\n  opacity: 0.63;\n  -webkit-backdrop-filter: blur(1px);\n  backdrop-filter: blur(1px);\n  background-color: #ffffff;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  top: 0;\n  position: absolute;\n  text-align: center;\n  font-size: 26px;\n  margin-right: 30px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/ui-elements/ui-table-multirow-spinner/ui-spinner.less
// module id = 1071
// module chunks = 3